import appEventData from "./appEventData";

type ClickEvent = {
  customLinkName: string;
  linkId: string;
  linkPosition: string;
};

const clickEvent = (clickEvent: ClickEvent) => {
  appEventData.push({
    event: "CTA Clicked",
    linkInfo: clickEvent,
  });
};

export default clickEvent;
